import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const clipEncoderComponent: ComponentDef = {
  id: 'clip-encoder',
  name: 'CLIP Encoder',
  description: 'Contrastive image-text encoder that aligns visual and textual representations.',
  category: 'multimodal',
  params: [
    { name: 'seq_len', label: 'Text length', type: 'number', default: 77, min: 1, max: 512, step: 1 },
    { name: 'n_patches', label: 'Image patches', type: 'number', default: 196, min: 1, max: 1024, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 }
  ],
  buildGraph: (params) => {
    const seq_len = Number(params.seq_len);
    const n_patches = Number(params.n_patches);
    const d_model = Number(params.d_model);

    const g = new GraphBuilder();
    g.input('image', [n_patches, d_model]);
    g.input('text', [seq_len, d_model]);

    g.conv('image_proj', 'image', [n_patches, d_model], 'ViT');
    g.linear('text_proj', 'text', [d_model, d_model]);
    g.fusion('joint', 'image_proj', 'text_proj', [1, d_model]);
    g.crossEntropy('contrastive', 'joint', 'text_proj');
    g.output('out', 'contrastive');
    return g.build();
  }
};
